<template>
    <v-app class="white">
    <div class="main_top">
        <!-- 제목 -->
        <div class="top_title_text">FAQ</div> 
        <!-- 옵션메뉴 -->
        <div class="btn-option-menu" 
        v-ripple="{ center: true, class: `teal--text`  }"
        @click.passive="onClickBack">
            <v-img 
            class="img-option-back"
            ma-0
            pa-0
            transition="false"
            :src="require('../assets/backkey.png')">
            </v-img>
        </div>
        </div>
        <div class="top_line">
        </div>
        
        <div class="list-main">
            <template v-for="(item, index) in mPushList">
                <div @click.passive="onClickPush(item)" v-ripple="{ center: true, class: `teal--text`  }"> 
                    <div class="list-main-date">
                        {{item.date}}
                    </div>                 
                    <div class="list-main-titie">
                        {{item.title}}
                    </div>     
                    
                    <div class="list-main-content">
                        {{item.contents}}
                    </div>
                
                    <img v-show="item.ImgUrl" :src=item.ImgUrl class="list-main-img"/>
                    <div class="list-main-line"> </div>
                </div>
            </template>
        </div>
    </v-app>
</template>
<script>
import { print } from 'util';
import axios from 'axios';
export default {
    created() {
        this.startApp();
        this.connectServer();
        //this.pushListServer('%7B%22result%22:%221%22,%22list%22:%5B%7B%22Contents%22:%22Meconcash%20will%20be%20global%20game%20company%20BACH%20TUOC%20SOs%20exclusive%20game%20money%20over%206%20countries%20where%20BACH%20TUOC%20SO%20has%20its%20active%20users%22,%22LinkUrl%22:%22http:%5C/%5C/www.meconcash.com%5C/%22,%22RegDate%22:%222019-07-01%2014:05%22,%22Title%22:%22Meconcash%20will%20be%20global%20game%20company%20BACH%20TUOC%20SO%22,%22ImgUrl%22:%22%22,%22Seq%22:237%7D%5D%7D')
        //this.pushListServer("%7B%22result%22%3A%221%22%2C%22list%22%3A%5B%7B%22Contents%22%3A%22%EC%97%90%ED%94%BD%EB%82%98%EC%9D%B4%EC%B8%A0%20%EA%B2%8C%EC%9E%84%EC%9D%98%20%EB%AF%B8%EC%BD%98%EC%BA%90%EC%8B%9C%20%EC%A0%81%EC%9A%A9%2C%20%EB%B3%B4%EC%83%81%2C%20%EA%B3%84%ED%9A%8D%20%EB%93%B1%EC%97%90%20%EB%8C%80%ED%95%9C%20%EC%86%8C%EA%B0%9C%EC%99%80%20%EA%B8%80%EB%A1%9C%EB%B2%8C%20%EC%A7%84%EC%B6%9C%20%EB%B0%A9%ED%96%A5%EC%9D%84%20%20%EB%B3%B4%EC%8B%A4%20%EC%88%98%20%EC%9E%88%EC%8A%B5%EB%8B%88%EB%8B%A4.%20%EB%AF%B8%EC%BD%98%EC%BA%90%EC%8B%9C%EC%9D%98%20%EA%B0%80%EC%B9%98%EB%A5%BC%20%ED%99%95%EC%9D%B8%ED%95%B4%20%EB%B3%B4%EC%84%B8%EC%9A%94.%22%2C%22LinkUrl%22%3A%22%22%2C%22RegDate%22%3A%222019-05-16%2009%3A56%22%2C%22Title%22%3A%2217%EC%9D%BC%20%EB%AF%B8%EC%BD%98%EC%BA%90%EC%8B%9CRPG%EA%B2%8C%EC%9E%84%20%ED%8C%8D%EC%8A%A4%EA%B2%BD%EC%A0%9CTV%20%EB%AA%85%EC%98%88%EC%9D%98%EC%A0%84%EB%8B%B9%20%EB%B0%A9%EC%86%A1%EC%98%88%EC%A0%95%21%22%2C%22ImgUrl%22%3A%22%22%2C%22Seq%22%3A226%7D%2C%7B%22Contents%22%3A%22%EC%95%94%ED%98%B8%ED%99%94%ED%8F%90%20%EA%B2%B0%EC%A0%9C%20%EC%8B%9C%EC%8A%A4%ED%85%9C%EC%9D%84%20%EC%A0%91%EB%AA%A9%ED%95%9C%20%EB%AA%A8%EB%B0%94%EC%9D%BC%20RPG%EA%B2%8C%EC%9E%84%20%5Cu2018%EC%97%90%ED%94%BD%EB%82%98%EC%9D%B4%EC%B8%A0%28Epic%20Knights%29%20%EA%B5%AC%EA%B8%80%20%ED%94%8C%EB%A0%88%EC%9D%B4%20%EC%84%9C%EB%B9%84%EC%8A%A4%EB%A5%BC%20%EC%A0%95%EC%8B%9D%20%EC%98%A4%ED%94%88%ED%95%98%EC%98%80%EC%8A%B5%EB%8B%88%EB%8B%A4.%20%EA%B2%8C%EC%9E%84%EC%9D%84%20%EC%A2%8B%EC%95%84%ED%95%98%EB%8A%94%20%EC%A0%8A%EC%9D%80%EC%B8%B5%EC%9D%98%20%EC%9C%A0%EC%A0%80%EC%99%80%20%ED%95%B4%EC%99%B8%20%EC%82%AC%EC%9A%A9%EC%9E%90%EB%93%A4%EC%97%90%EA%B2%8C%20%EB%AF%B8%EC%BD%98%EC%BA%90%EC%8B%9C%EC%99%80%20%EC%97%A0%ED%8E%98%EC%9D%B4%28M.PAY%29%20%EA%B2%B0%EC%A0%9C%20%EC%84%9C%EB%B9%84%EC%8A%A4%EB%A5%BC%20%ED%99%95%EB%8C%80%ED%95%A0%20%EC%88%98%20%EC%9E%88%EB%8A%94%20%EA%B8%B0%ED%9A%8C%EA%B0%80%20%EB%90%A0%20%EA%B2%83%EC%9C%BC%EB%A1%9C%20%EA%B8%B0%EB%8C%80%ED%95%A9%EB%8B%88%EB%8B%A4.%5Cn%EB%8B%A4%EC%96%91%ED%95%9C%20%EC%BD%98%ED%85%90%EC%B8%A0%EB%A5%BC%20%EC%97%85%EB%8D%B0%EC%9D%B4%ED%8A%B8%EB%A5%BC%20%EC%A7%84%ED%96%89%ED%95%B4%20%EC%9E%AC%EB%AF%B8%EB%A5%BC%20%EA%B7%B9%EB%8C%80%ED%99%94%ED%95%A0%20%EC%98%88%EC%A0%95%EC%9D%B4%EB%A9%B0%2C%20%EA%B2%8C%EC%9E%84%20%EC%8B%A4%ED%96%89%EC%9D%84%20%EC%9C%A0%EC%A7%80%ED%95%98%EB%8A%94%20%EA%B2%BD%EC%9A%B0%20%EB%A7%88%EC%9D%B4%EB%8B%9D%20%ED%8F%AC%EC%9D%B8%ED%8A%B8%EB%A5%BC%20%EB%B0%9C%EC%83%9D%EC%8B%9C%EC%BC%9C%20%EC%9D%B4%EB%A5%BC%20%EB%AF%B8%EC%BD%98%EC%BA%90%EC%8B%9C%28Meconcash%29%EB%A1%9C%20%EC%A0%84%ED%99%98%ED%95%A0%20%EC%88%98%20%EC%9E%88%EB%8A%94%20%EB%B8%94%EB%A1%9D%EC%B2%B4%EC%9D%B8%20%EB%B3%B4%EC%83%81%ED%98%95%20%EC%8B%9C%EC%8A%A4%ED%85%9C%EC%9D%84%20%EA%B5%AC%EC%B6%95%ED%95%A0%20%EA%B3%84%ED%9A%8D%EC%9E%85%EB%8B%88%EB%8B%A4.%22%2C%22LinkUrl%22%3A%22%22%2C%22RegDate%22%3A%222019-05-15%2018%3A27%22%2C%22Title%22%3A%22%EC%97%A0%ED%8E%98%EC%9D%B4%28M.PAY%29%20%EC%A0%81%EC%9A%A9%ED%95%9C%20%5Cu2018%EC%97%90%ED%94%BD%EB%82%98%EC%9D%B4%EC%B8%A0%5Cu2019%20%EB%AA%A8%EB%B0%94%EC%9D%BC%20RPG%20%EA%B2%8C%EC%9E%84%20%EC%B6%9C%EC%8B%9C%22%2C%22ImgUrl%22%3A%22%22%2C%22Seq%22%3A225%7D%2C%7B%22Contents%22%3A%22%ED%95%98%EB%82%98%ED%95%98%EB%82%98%20%EC%84%A4%EC%B9%98%ED%95%A0%EB%95%8C%EB%A7%88%EB%8B%A4%203M.Pay%EC%94%A9%20%EC%B4%9D9M.Pay%EC%A7%80%EA%B8%89%22%2C%22LinkUrl%22%3A%22%22%2C%22RegDate%22%3A%222019-05-15%2013%3A18%22%2C%22Title%22%3A%22%5B%EC%9D%B4%EB%B2%A4%ED%8A%B8%5D%EC%B6%94%EC%B2%9C%EC%96%B4%ED%94%8C%20%EC%84%A4%EC%B9%98%ED%95%98%EA%B3%A0%20M.Pay%20%EB%B0%9B%EC%9E%90%22%2C%22ImgUrl%22%3A%22https%3A%5C%2F%5C%2Fs3.ap-northeast-2.amazonaws.com%5C%2Fmeconcash-web-asset%5C%2Fmeconcash-app%5C%2F5284160d-ac29-420f-a525-f9546b450351_push_info_0515.png%22%2C%22Seq%22%3A221%7D%5D%7D");
    },
    data: () => ({
        mPushList : [],
    }),    
    methods : {
        startApp: function() {
            try {
                window.MeconWalletJS.initApp();
            } catch(error) {
            }
            try {
                let param = {};
                param.key = "initApp";
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(param));
            } catch(error) {
            }
        },
        connectServer() {
            let payload = {};
            payload.cmd = "get-faq-list";
            this.mShowLoading = true;
            axios.post(this.$httpConst.URL, this.$cryptoUtil.xorEncryption(JSON.stringify(payload), "K"))
            .then(response => {
                let serverResponse = JSON.parse(this.$cryptoUtil.xorDecryption(response.data, "K"));
                this.mShowLoading = false;
                console.log(serverResponse);
            })
            .catch( ()=>{} );
        },
        pushListServer : function(msg) {
            this.mPushList = [];
            let serverVal = unescape(decodeURI(msg));

            serverVal = serverVal.replace(/\s+/, "");//왼쪽 공백제거
            serverVal = serverVal.replace(/\s+$/g, "");//오른쪽 공백제거
            serverVal = serverVal.replace(/\n/g, "");//행바꿈제거
            serverVal = serverVal.replace(/\r/g, "");//엔터제거

            console.log("element :" + serverVal )
            let json = JSON.parse(serverVal);
            json.list.forEach(element => {
                this.mPushList.push(element);
            });
            console.log("element :" + JSON.stringify(this.mPushList) )
        },
        onClickBack : function() {
            this.$router.go(-1);            
        },
        onClickPush : function(msg) {
            try {
                window.MeconWalletJS.onClickPush(msg.LinkUrl);
            } catch(error) {
            }
            try {
                let param = {};
                param.key = "onClickPush";
                param.link = msg.LinkUrl;
                window.webkit.messageHandlers.callbackHandler.postMessage(JSON.stringify(param));
            } catch(error) {
            }   
        }
    }
}
</script>
<style scoped>
* {
    margin: 0;
    font-family: "HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: 300;
    padding: 0;
}
html, body {
    height: 100vw;
    width: 100vw;
}
.list-main {
    position: absolute;
    width: 90vw;
    height: 90vh;
    top: 12.62vw;
    left: 5vw; 
    overflow: scroll;
    overflow-y: auto;
    overflow-x: hidden;
}
.list-main-content {
    width: 100%; 
    font-size: 3vw;
    color: gray;
    margin-top: 1vw;
    margin-bottom: 1vw;
}
.list-main-titie {
    width: 100%; 
    font-size: 3vw;
    color: black;
    margin-top: 2vw;
}
.list-main-date {
    width: 100%; 
    font-size: 3vw;
    margin-top: 2vw;
}
.list-main-line {
    width: 100%;
    height: 1px;
    background-color: lightgray;
}
.list-main-img {
    width: 100%;
    height: auto;
    margin-top: 2vw;
}
  .main_top {
    position: absolute;
    height: 7.1vh;
    width: 100vw;
    display: inline-block;
    top: 0vh;
  }
  .top_title_text {
    color: #075a81;
    text-align: center;
    width: 100vw;
    right: 0vw;
    font-size: 3.9vw;
    display: inline-block;
    position: absolute;
    top: 4.12vw;
    font-weight: bold;
  }
  .btn-option-menu {
    position: absolute;
    width: 15vw;
    height: 13vw;
    top: 0vw;
    left: 0vw;
  }
  .img-option-back {
    position: absolute;  
    top: 3.2vw;
    left: 5vw;        
    width: 2.7vw;
    height: 5.1vw;  
  }
  .top_line {
    position: absolute;
    width: 100vw;
    height: 1px;
    top: 12.62vw;
    left: 0vw; 
    background-color: #1b6aad;
  }
</style>
